module.exports = __webpack_public_path__ + "static/media/info_icon.b260c186.svg";